import React from 'react';
import {
  CheckCircleOutline,
  FileUploadOutlined,
  SwipeLeftOutlined,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { TimeStatus } from '../../Constant/Constant';
import BtnDropDown from '../../../../atoms/Buttons/BtnDropDown';
const DropActionForAttendance = (props) => {
  const {
    checkedItems,
    handleApprove,
    handleReject,
    attendanceIdPropertiesMap,
  } = props;
  const { timeManagementPermission } = useSelector(
    (state) => state.modulePermissions
  );

  const empApproveDisabled = !!checkedItems.find(
    (item) =>
      attendanceIdPropertiesMap?.[item]?.empStatusCode ===
        TimeStatus.Approved ||
      attendanceIdPropertiesMap?.[item]?.empStatusCode ===
        TimeStatus.Rejected
  );
  const mgrApproveDisabled = !!checkedItems.find(
    (item) =>
      attendanceIdPropertiesMap?.[item]?.mgrStatusCode ===
        TimeStatus.Approved ||
      attendanceIdPropertiesMap?.[item]?.mgrStatusCode ===
        TimeStatus.Rejected
  );
  const hrApproveRejectDisabled = !!checkedItems.find(
    (item) =>
      attendanceIdPropertiesMap?.[item]?.hrStatusCode ===
        TimeStatus.Approved ||
      attendanceIdPropertiesMap?.[item]?.hrStatusCode ===
        TimeStatus.Rejected
  );

  const tmtActionBtndisbaled = () => {
    switch (true) {
      case timeManagementPermission?.['attendance']?.viewAccess === 7 &&
        hrApproveRejectDisabled:
        return true;
      case timeManagementPermission?.['attendance']?.viewAccess === 4 &&
        mgrApproveDisabled:
        return true;
      case timeManagementPermission?.['attendance']?.viewAccess === 1 &&
        empApproveDisabled:
        return true;
      default:
        return false;
    }
  };

  const timeBtnOption = [
    {
      id: 1,
      title: 'Approve',
      icon: <CheckCircleOutline sx={{ width: 20, height: 20 }} />,
      handleClick: handleApprove,
      hide: false,
      disabled: !checkedItems.length || tmtActionBtndisbaled(),
    },
    {
      id: 2,
      title: 'Reject',
      icon: <SwipeLeftOutlined sx={{ width: 20, height: 20 }} />,
      handleClick: handleReject,
      hide: timeManagementPermission?.['attendance']?.viewAccess !== 7,
      disabled: !checkedItems.length || tmtActionBtndisbaled(),
    },
  ];
  return (
    <BtnDropDown
      BtnOptions={timeBtnOption.filter((item) => !item.hide)}
      selectedOption={0}
    />
  );
};

export default DropActionForAttendance;
